module.exports = __webpack_public_path__ + "img/icons_21.58c26652.svg";